
import { BaseURL } from './Api';
import {axiosClient} from './AxiosClient';
export const apiInstance = axiosClient(BaseURL);
